import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { CatalogGitService } from './catalog-git.service';

@Injectable({ providedIn: 'root' })
export class CatalogGitFactoryService extends AbstractGitFactoryService<CatalogGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: CatalogGitService,
    });
  }
}
